<template>
  <img :src="props.imageUrl" :alt="props.alt" />
</template>

<script setup lang="ts">
const props = defineProps({
  imageUrl: { type: String, required: true },
  alt: { type: String, required: true },
});
</script>

<style scoped>
img {
  max-width: 100%;
  margin: 0 auto;
}
</style>
